export const gdprKeys = {
  all: ['gdpr'],
  lists: () => [...gdprKeys.all, 'list'],
  list: () => [...gdprKeys.lists()],
} as const;
